import React from "react";
import { connect } from "react-redux";
import { Tabs } from "../../Tabs";
import List from "./List";
import language from "../../../language";
import NewTransfer from "./Transfer";
import { getStorage } from "../../../utils/storage";
import { ROLE_PACKAGING } from "../../../constants/ROLES";
import { defineRole } from "../../../utils/handleAccessRoles";

class Packaging extends React.Component {
  state = {
    user: {},
  };

  componentDidMount = async () => {
    const user = await getStorage();
    this.setState({ user });
  };

  render() {
    const canCreatePackaging = defineRole({
      roles: this.state.user.accessRole,
      menu: ROLE_PACKAGING,
      operation: "create",
    });

    const canReadPackaging = defineRole({
      roles: this.state.user.accessRole,
      menu: ROLE_PACKAGING,
      operation: "read",
    });

    return (
      <div>
        <Tabs
          options={[
            canCreatePackaging && {
              title: language[this.props.defaultLanguage].new_record,
              data: (
                <div className="card">
                  <div className="card-body">
                    <div className="col-md-6">
                      <NewTransfer status="transferred" />
                    </div>
                  </div>
                </div>
              ),
            },
            canCreatePackaging && {
              title: language[this.props.defaultLanguage].receive,
              data: (
                <div className="card">
                  <div className="card-body">
                    <div className="col-md-6">
                      <NewTransfer status="received" />
                    </div>
                  </div>
                </div>
              ),
            },
            canReadPackaging && {
              title: language[this.props.defaultLanguage].historical_data,
              data: <List status={this.props.status} type={this.props.type} />,
            },
          ].filter(Boolean)}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(Packaging);
